
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdatePledge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"pledge"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdatePledgeInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updatePledge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pledge"},"value":{"kind":"Variable","name":{"kind":"Name","value":"pledge"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Pledge"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"TimelinePledge"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"GivingHistoryPledge"},"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"sendInvoiceVia"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"backupFiles"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DonorFile"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"donor"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DonorFields"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"givingSummary"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"lifetimeTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"largestGift"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"latestGift"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstGift"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastYearTotal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thisYearTotal"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":574}};
    doc.loc.source = {"body":"#import '@/shared/fragments/timeline.graphql'\n#import '@/shared/fragments/donor-file.fragment.graphql'\n#import '@/shared/fragments/giving-history-pledge.graphql'\n\nmutation UpdatePledge($pledge: UpdatePledgeInput!) {\n\tupdatePledge(pledge: $pledge) {\n\t\t... on Pledge {\n\t\t\t...TimelinePledge\n\t\t\t...GivingHistoryPledge\n\t\t\tsendInvoiceVia\n\t\t\tbackupFiles {\n\t\t\t\t...DonorFile\n\t\t\t}\n\t\t\tdonor {\n\t\t\t\t... on DonorFields {\n\t\t\t\t\tid\n\t\t\t\t\tgivingSummary {\n\t\t\t\t\t\tlifetimeTotal\n\t\t\t\t\t\tlargestGift\n\t\t\t\t\t\tlatestGift\n\t\t\t\t\t\tfirstGift\n\t\t\t\t\t\tlastYearTotal\n\t\t\t\t\t\tthisYearTotal\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require('@/shared/fragments/timeline.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('@/shared/fragments/donor-file.fragment.graphql').definitions));
doc.definitions = doc.definitions.concat(unique(require('@/shared/fragments/giving-history-pledge.graphql').definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["UpdatePledge"] = oneQuery(doc, "UpdatePledge");
        
